import mutations from "./mutations";
import actions from "./actions";

const state = {
  allShippingApplications: [],
  shippingRequestsAwaitingProcessing: [],
  shippingRequestsPendingApproval: [],
  shippingRequestsApproved:[],
  shippingRequestsDisapproved:[],
  shippingRequestsFailedProcessing: [],
  selectedShippingRequest: {},
  searchResults: [],
  portsBerthedApplications: []
};

const getters = { 

  getAllShippingApplications: state => {
    return state.allShippingApplications
  },

  getSearchResults: state =>{
    return state.searchResults;
  },

  getPortsBerthedShipments: state => {
    return state.portsBerthedApplications
  },

  //
  shippingRequestsAwaitingProcessing: state => {
    return state.shippingRequestsAwaitingProcessing;
  },

  shippingRequestsPendingApproval: state => {
    return state.shippingRequestsPendingApproval;
  },

  shippingRequestsFailedProcessing: state => {
    return state.shippingRequestsFailedProcessing;
  },

  shippingRequestsApprovedApplications: state => {
    return state.shippingRequestsApproved
  },

  shippingRequestsDisapprovedApplications: state => {
    return state.shippingRequestsDisapproved
  },

  isNimasaAgent: (state, getters, rootState) => {
    return rootState.userRoles[0] === "NIMASA_USER";
  },

  isNimasaManager: (state, getters, rootState) => {
    return rootState.userRoles[0] === "NIMASA_MANAGER";
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
